import axiosService from '../plugins/axiosService'
import axiosServiceNest from '../plugins/axiosServiceNest'
const NEST_API_URL = process.env.VUE_APP_NEST_API_BASE_URL || 'http://localhost:3003'


export default {
    async login(param){
        return axiosService.post('/api/user/login',param)
    },
    async logout(param){
        return axiosService.post('/api/user/logout',param)
    },
    async userUpdate(param){
        return axiosService.post('/api/back/user/update',param)
    },
    async sendMessage(param) {
        try {
            const response = await axiosServiceNest.post('/api/send/mail', param);
            return response.data;
        } catch (error) {
            console.error('Erreur lors de l\'envoi du mail :', error);
            this.errorMessage = 'Une erreur est survenue lors de l\'envoi du mail';
            return Promise.reject(error);
        }
    }

}
